module.exports = __webpack_public_path__ + "ClientApp/content/LOV_map.png";